<template>
  <!-- eslint-disable max-len -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 50 50"
    :aria-labelledby="iconName"
    role="presentation"
  >
    <path
      d="M44.6558 50H5.29891C3.89217 49.996 2.54424 49.4345 1.55094 48.4383C0.557632 47.4422 -5.67673e-06 46.0927 0 44.6859V5.29895C0 3.89358 0.558306 2.54579 1.55204 1.55205C2.54578 0.55831 3.89355 0 5.29891 0H44.686C46.0927 -5.67677e-06 47.4419 0.557636 48.438 1.55095C49.4341 2.54426 49.996 3.8922 50 5.29895V44.7615C49.9762 46.1617 49.402 47.4964 48.4019 48.4767C47.4018 49.457 46.0562 50.0041 44.6558 50ZM5.29891 1.50967C4.29516 1.51364 3.3336 1.91409 2.62384 2.62386C1.91408 3.33362 1.51363 4.29519 1.50966 5.29895V44.7615C1.50965 45.7678 1.90849 46.7331 2.61868 47.4461C3.32887 48.1592 4.29255 48.5619 5.29891 48.5659H44.686C45.695 48.5659 46.6623 48.1651 47.3758 47.4517C48.0892 46.7382 48.4903 45.7705 48.4903 44.7615V5.37413C48.4864 4.36777 48.0837 3.40408 47.3706 2.69389C46.6576 1.98369 45.6923 1.58485 44.686 1.58486L5.29891 1.50967Z"
      fill="black"
    />
    <path
      d="M12.5 13L14 12H31L34.5 15L38 19.5V36.5L37.5 37.5L36.5 38H13.5L12.5 37.5L12 36V14L12.5 13Z"
      fill="#87CBDE"
    />
    <circle cx="25" cy="30" r="5" fill="white" />
    <rect x="16" y="12" width="14" height="8" fill="white" />
    <path
      d="M37.8125 17.875L32.125 12.1875C31.375 11.4375 30.375 11 29.3125 11H15C12.75 11 11 12.8125 11 15V35C11 37.25 12.75 39 15 39H35C37.1875 39 39 37.25 39 35V20.6875C39 19.625 38.5625 18.625 37.8125 17.875ZM16 12H29.3125C29.5625 12 29.75 12.0625 30 12.125V18.5C30 19.375 29.3125 20 28.5 20H17.5C16.625 20 16 19.375 16 18.5V12ZM38 35C38 36.6875 36.625 38 35 38H15C13.3125 38 12 36.6875 12 35V15C12 13.375 13.3125 12 15 12V18.5C15 19.9375 16.0625 21 17.5 21H28.5C29.875 21 31 19.9375 31 18.5V12.5C31.125 12.625 31.3125 12.75 31.4375 12.9375L37.0625 18.5625C37.6875 19.125 38 19.875 38 20.6875V35ZM25 24C21.9375 24 19.5 26.5 19.5 29.5C19.5 32.5625 21.9375 35 25 35C28 35 30.5 32.5625 30.5 29.5C30.5 26.5 28 24 25 24ZM25 34C22.5 34 20.5 32 20.5 29.5C20.5 27.0625 22.5 25 25 25C27.4375 25 29.5 27.0625 29.5 29.5C29.5 32 27.4375 34 25 34Z"
      fill="black"
    />
  </svg>
</template>

<script>
import BaseIcon from 'mixins/BaseIcon';

export default {
  mixins: [BaseIcon]
};
</script>
